"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/* Words and dates the Forms screens share on web and mobile: the chat card,
 * the send sheet, the status view, the Sent tab and refused commands. */
var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);

var _links = require('./links');





/* "Nov 1" */
 const formDay = (t) => _moment2.default.call(void 0, t).format('MMM D'); exports.formDay = formDay

/* "Today 2:41 PM", "Yesterday 8:10 PM", else "Nov 12". */
 const formWhen = (t, now = _moment2.default.call(void 0, )) => {
  const m = _moment2.default.call(void 0, t)
  if (m.isSame(now, 'day')) return `Today ${m.format('LT')}`
  if (m.isSame(now.clone().subtract(1, 'day'), 'day')) return `Yesterday ${m.format('LT')}`
  return m.format('MMM D')
}; exports.formWhen = formWhen

/* A date the family reads on a form, as the signed PDF prints it: "November
 * 1, 2026" from the stored "2026-11-01" (formDate in forms_completion.go).
 * Anything else shows as typed. */
 const FORM_DATE_FORMAT = 'MMMM D, YYYY'; exports.FORM_DATE_FORMAT = FORM_DATE_FORMAT
 const formDate = (value) => {
  const day = _moment2.default.call(void 0, value, 'YYYY-MM-DD', true)
  return day.isValid() ? day.format(exports.FORM_DATE_FORMAT) : value
}; exports.formDate = formDate

/* A log's month ("November"). LogMonth is the month's first day in UTC. */
 const logMonthName = (t) => _moment2.default.utc(t).format('MMMM'); exports.logMonthName = logMonthName

 const firstName = (name) => name.trim().split(/\s+/)[0] || name; exports.firstName = firstName

 const isLogForm = (fields) =>
  !!_optionalChain([fields, 'optionalAccess', _ => _.some, 'call', _2 => _2(field => field.type === 'rows')]); exports.isLogForm = isLogForm

/* The fields staff fill before sending. */
 const staffFields = (fields) =>
  fields.filter(field => field.filler === 'staff' && field.type !== 'rows'); exports.staffFields = staffFields

 const isOpenStatus = (status) => status === 'sent' || status === 'in_progress'; exports.isOpenStatus = isOpenStatus

const rowCount = (n) => `${n} ${n === 1 ? 'row' : 'rows'}`

/* The chip: Sent, In progress, Completed {date}, Expired {date}. */
 const statusChip = (card, withRows = false) => {
  switch (card.Status) {
    case 'completed':
      return { tone: 'done' , label: _links.isSetTime.call(void 0, card.SubmittedAt) ? `Completed ${exports.formDay.call(void 0, card.SubmittedAt)}` : 'Completed' }
    case 'expired':
      return { tone: 'expired' , label: `Expired ${exports.formDay.call(void 0, card.ExpiresAt)}` }
    case 'in_progress':
      return {
        tone: 'progress' ,
        label: withRows ? `In progress · ${rowCount(card.RowCount)}` : 'In progress',
      }
    default:
      return { tone: 'sent' , label: 'Sent' }
  }
}; exports.statusChip = statusChip

/* The card's title: "{Form} · {child}", and the month for a log. */
 const formCardTitle = (card) => {
  const month = _links.isSetTime.call(void 0, card.LogMonth) ? ` · ${exports.logMonthName.call(void 0, card.LogMonth)}` : ''
  return `${card.FormName}${card.PatientName ? ` · ${card.PatientName}` : ''}${month}`
}; exports.formCardTitle = formCardTitle

const lowerFirst = (s) => s.charAt(0).toLowerCase() + s.slice(1)

/* The line under the card's title: who signed, the log's rows, or when the link expires. */
 const formCardDetail = (card) => {
  if (card.Status === 'completed') return card.SignerName ? `Signed by ${card.SignerName}` : ''
  if (card.Status === 'expired') return ''
  if (card.RowCount > 0) {
    const last = _links.isSetTime.call(void 0, card.LastRowAt) ? ` · last ${lowerFirst(exports.formWhen.call(void 0, card.LastRowAt))}` : ''
    return `${rowCount(card.RowCount)}${last}`
  }
  return `link expires ${exports.formDay.call(void 0, card.ExpiresAt)}`
}; exports.formCardDetail = formCardDetail

/* The month a log is sent for. */
 const logMonthOf = (which, now = _moment2.default.call(void 0, )) => now.clone().add(which === 'next' ? 1 : 0, 'month'); exports.logMonthOf = logMonthOf

/* The message a form goes out with, before staff edit it. */
 const defaultFormMessage = (formName, recipientName, log, which) => {
  const hi = recipientName ? `Hi ${exports.firstName.call(void 0, recipientName)}, ` : ''
  return log
    ? `${hi}please add each entry to ${formName} for ${exports.logMonthOf.call(void 0, which).format('MMMM')}, and sign at the end of the month.`
    : `${hi}please fill in and sign ${formName}.`
}; exports.defaultFormMessage = defaultFormMessage

/* The staff values copied from this family's last send of the form, and the
 * note that says where they came from ('' when nothing was copied). */
 const sendPrefill = (
  fields,
  prefill,
  recipientName,
) => {
  const ids = new Set(exports.staffFields.call(void 0, fields).map(field => field.id))
  const values = Object.fromEntries(Object.entries(_optionalChain([prefill, 'optionalAccess', _3 => _3.StaffValues]) || {}).filter(([id]) => ids.has(id)))
  let copiedNote = ''
  if (prefill && _links.isSetTime.call(void 0, prefill.CopiedFrom)) {
    const who = exports.firstName.call(void 0, recipientName) || 'this patient'
    copiedNote = exports.isLogForm.call(void 0, fields)
      ? `Copied from the ${_links.isSetTime.call(void 0, prefill.CopiedLog) ? exports.logMonthName.call(void 0, prefill.CopiedLog) : _moment2.default.call(void 0, prefill.CopiedFrom).format('MMMM')} log you sent ${who}.`
      : `Copied from the form you sent ${who} on ${exports.formDay.call(void 0, prefill.CopiedFrom)}.`
  }
  return { values, copiedNote }
}; exports.sendPrefill = sendPrefill



/* The server said this person may not run the command ("unauthorized command"). */
 const isUnauthorized = (err) => {
  const { Status, Error: message } = (_nullishCoalesce(err, () => ( {}))) 
  return Status === 'unauthorized' || message === 'unauthorized command'
}; exports.isUnauthorized = isUnauthorized

/* What a refused Forms command says: `unauthorized` when the person may not
 * do it, a client error's own message, else the fallback. */
 const formsErrorText = (err, fallback, unauthorized = "You can't do that here.") => {
  if (exports.isUnauthorized.call(void 0, err)) return unauthorized
  const { Status, Error: message, ServerError } = (_nullishCoalesce(err, () => ( {}))) 
  const isClientError = Status === 'client_error' || ServerError === false
  return isClientError && typeof message === 'string' && message ? message : fallback
}; exports.formsErrorText = formsErrorText
